module.exports = __webpack_public_path__ + "static/img/11.9b6dd95.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Content/Friend/11.png
// module id = 6Sjj
// module chunks = 12